import { observer } from "mobx-react";
import React, { useEffect, useState } from "react";
import {
  commaSeperated2,
  displayUnit,
  getLimitPer,
} from "../../utils/functions";

const Bar = observer(
  ({
    item,
    index,
    containerStyles,
    is_xirr = "irr",
    percentWidth,
    creditWidth,
    maxPercent,
  }) => {
    const [showText, setShowText] = useState(false);
    const [isOverflowing, setIsOverflowing] = useState(false);
    const ref = React.createRef();

    useEffect(() => {
      if (ref.current.clientWidth < ref.current.scrollWidth) {
        setIsOverflowing(true);
      }
    }, [ref, item?.instrument?.name]);

    const color = {
      true: {
        backgroundFillColor: "#DFF8E6",
        color: "#46D787",
        allocationColor: "#01D684",
        //percentColor: "#46D787",
        percentColor: "#007A32",
      },
      false: {
        backgroundFillColor: "#FFE1DC",
        color: "#FF6258",
        allocationColor: "#FF5252",
        percentColor: "#FF857D",
      },
    };

    const fillPercent = Math.abs(
      is_xirr === "irr"
        ? item?.investmentPerformance?.return_percentage
        : item?.abs_val,
    );
    const withMinusSign =
      is_xirr === "irr"
        ? item?.investmentPerformance?.return_percentage
        : item?.abs_val;
    const getColor = () => color[withMinusSign >= 0];

    const handleClick = () => {
      setShowText(!showText);
      let e = window.event;
      e.cancelBubble = true;
      e?.stopPropagation();
    };

    return (
      <div
        className="bar"
        style={{
          borderLeftColor: getColor()?.color,
          width: "100%",
          position: "relative",
          ...containerStyles,
        }}
        key={index}
      >
        <div
          style={{
            "--fill-width": `${
              (fillPercent / maxPercent) * 100 > 100
                ? 100
                : (fillPercent / maxPercent) * 100
            }%`,
            backgroundColor: getColor()?.backgroundFillColor,
          }}
          className="fill-animation"
        />
        <span
          className="bar-text-container"
          style={{ width: `calc(100% - ${creditWidth + percentWidth + 50}px)` }}
        >
          <span
            style={{
              display: "flex",
              cursor: isOverflowing ? "pointer" : "text",
            }}
            onClick={isOverflowing ? handleClick : undefined}
          >
            <span
              ref={ref}
              className="content-text"
              style={{
                height: showText ? "auto" : 20,
                overflow: showText ? "auto" : "hidden",
                whiteSpace: showText ? "inherit" : "nowrap",
              }}
            >
              {item?.instrument?.name}
            </span>
            {isOverflowing && !showText && (
              <button
                className="content-text show-button"
                style={{
                  display: "flex",
                  alignItems: "flex-end",
                  width: 80,
                }}
              >
                {isOverflowing && <b>Show</b>}
              </button>
            )}
          </span>
          <span
            className="allocation-text"
            style={{ color: getColor()?.allocationColor }}
          >
            Allocation {commaSeperated2(item?.allocation_percentage)}%
          </span>
        </span>

        <span
          className="bar-percent-text-container"
          style={{ width: creditWidth + percentWidth + 25 }}
        >
          <span className="credits" style={{ width: creditWidth }}>
            {commaSeperated2(item?.current_value?.value)}
            &nbsp;
            <span className="unitSpan">
              {displayUnit(item?.current_value?.value_type)}
            </span>
          </span>
          <span
            className="percent"
            style={{
              width: percentWidth,
              color: getColor()?.percentColor,
            }}
          >
            {withMinusSign < 0 ? "-" : ""}
            {getLimitPer(fillPercent)}%
          </span>
        </span>
      </div>
    );
  },
);
export default Bar;
